<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="p-0 flex-nowrap flex-row headline">
        <span class="pl-4 title">Task context:</span>
      </v-card-title>
      <v-card-text>
        <pre class="json-preview">{{ context | jsonBeautify }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.json-preview {
  white-space: pre-wrap;
}
</style>
<script>
export default {
  data() {
    return {
      dialog: false,
      context: ''
    };
  },
  methods: {
    open(contextObject) {
      this.dialog = true;
      this.context = contextObject;
    },
    close() {
      this.dialog = false;
    }
  },
  filters: {
    jsonBeautify(jsonObject) {
      return JSON.stringify(jsonObject, null, 2);
    }
  }
};
</script>
